import { AuthTypes, ContentType, ContentStatus } from 'enums';
import { getAccessMethodFromAuthTypes } from 'lib/auth';
/**
 * Utility functions to format tracking data
 */

function isCollectionsPage({ id: pageId = '', name: pageName = ''}) {
    return (pageId !== 'espnplus' && pageId !== pageName.toLowerCase());
}

export function getVideoTypeFromContent(content = {}) {
    if (content.status) {
        // if the status of the event is over, it's linear, and the previous event was selected, so actually live
        if (content.status === ContentStatus.OVER) {
            return ContentStatus.LIVE;
        }
        return content.status;
    }
    return ContentType.VOD;
}

export function getVideoTypeFromStream(stream = {}) {
    if (stream.status) {
        // if the status of the event is over, it's linear, and the previous event was selected, so actually live
        if (stream.status === ContentStatus.OVER) {
            return ContentStatus.LIVE;
        }
        return stream.status;
    }
    return ContentType.VOD;
}

export function getOmniturePageName(page) {
    const { id: pageId = '', name: pageName = '' } = page;
    const formattedPageName = pageName.toLowerCase();
    const formattedPageId = pageId.toLowerCase();
    return (!isCollectionsPage(page) ? formattedPageId : `${formattedPageId}:${formattedPageName}`);
}

export function getOmniturePageData(page) {
    const { name: pageName = '' } = page;
    const formattedPageName = pageName.toLowerCase();

    const omniturePageName = getOmniturePageName(page);
    // if collections page, add prop35
    const collectionsPageData = {};
    if (isCollectionsPage(page)) {
        collectionsPageData.prop35 = formattedPageName;
    }

    const pageData = {
        pageName: omniturePageName,
        sections: omniturePageName,
        section: omniturePageName,
        // only the schedule page has a different contentType... just do as we're told
        contentType: (formattedPageName === 'schedule') ? 'schedule' : 'index'
    };

    return { ...pageData, ...collectionsPageData };
}

export function getOmnitureAuthData(userAuth = [], provider = {}, isDomestic = true) {
    const authenticated = (userAuth.indexOf(AuthTypes.MVPD) !== -1 || userAuth.indexOf(AuthTypes.ISP) !== -1);
    const authenticationStatus = getAccessMethodFromAuthTypes(userAuth);
    const pathname = window && window.location && window.location.pathname
    const notOnSyndicatedPlayerPage = pathname.indexOf('/syndicated/player') === -1;
    let providerName = 'not authenticated';
    let providerPackageName = 'not authenticated';

    if (authenticated === true) {
        // Only assign once authenticated and the `provider` object contains the `name` property
        if (provider.name) {
            providerName = provider.name;
        }

        // NOTE: Domestic Providers use the `abbreviation` property, it should never be `unavailable`
        if (isDomestic) {
            if (provider.abbreviation) {
                providerPackageName = provider.abbreviation;
            }
        } else {
            const { package: providerPackage = {} } = provider;
            // NOTE: The only instance `providerPackageName` will be `unavailable` is if there is no match found
            // via a mismatch with the `consumerKey` property in the packages array and the Adobe `packageId`.
            // See: `authenticationActions.js - createSmartAdobePassInitializeAction` function.
            providerPackageName = providerPackage.packageName || providerPackage.name || 'unavailable';
        }
    }

    const authnData = {
        eVar17: providerName,
        prop42: providerName,
        prop43: providerPackageName,
        eVar68: authenticationStatus
    };

    if (notOnSyndicatedPlayerPage) {
        authnData.eVar32 = providerPackageName
    }

    return authnData;
}

export function getOmnitureUserTrackingData(isLoggedIn, userTracking) {
    const {sessionId = 'No Device ID', deviceId = 'No Session ID', accountId = 'No Account ID'} = userTracking || {};
    let eVar102 = '';
    if (isLoggedIn) {
        eVar102 = `${deviceId},${sessionId},${accountId}`
    } else {
        eVar102 = `${deviceId},${sessionId}`
    }
    return eVar102;
}

export function getOmnitureEntitlementsData( payload ) {
    const { purchaseMethod, subscriberType, entitlements, oneIdLoggedIn, userTracking, hasSupderSundle }  = payload || {};
    // get eVar102 user tracking string
    const eVar102 = getOmnitureUserTrackingData(oneIdLoggedIn, userTracking);
    if (!entitlements) {
        return {
            eVar102
        };
    }

    const eVar104 = hasSupderSundle ? 'Yes' : 'No';
    const data = {
        eVar104,
        eVar102,
        eVar87: subscriberType,
        list1: entitlements,
        list2: purchaseMethod
    };
    return data;
}

export function getOmnitureQuery(query = {}) {
    const omnitureQuery = Object.keys(query).filter((key) => key.indexOf('om-') === 0).reduce((acc, key) => {
        acc[key] = query[key];
        return acc;
    }, {});

    return omnitureQuery;
}



// WEBPACK FOOTER //
// ./app/lib/omniture/format.js